import { ChangeEvent } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

type SelectFieldProps = {
  id: string;
  name: string;
  label?: string;
  value?: string | number;
  options?: Array<{ label: string; value: string | number }>;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  initialOptionLabel?: string;
  initialOptionValue?: string;
  inputProps?: Record<string, unknown>;
  helperText?: string;
  size?: 'small' | 'medium';
};

const CustomTextField = styled(TextField)(({ disabled }) => ({
  '& .MuiSelect-select.Mui-disabled': {
    '-webkit-text-fill-color': disabled ? '#000' : 'inherit',
    color: disabled ? '#000' : 'inherit',
  },
  '& .MuiSelect-icon': {
    display: disabled ? 'none' : 'block',
  },
}));

// eslint-disable-next-line react/function-component-definition
const SelectField = ({
  id,
  name,
  label,
  value,
  options,
  onChange,
  helperText,
  inputProps = {},
  disabled = false,
  initialOptionLabel,
  initialOptionValue,
  size = 'medium',
}: SelectFieldProps) => (
  <CustomTextField
    id={id}
    fullWidth
    size={size}
    name={name}
    select
    label={label}
    value={value}
    onChange={onChange}
    variant="outlined"
    disabled={disabled}
    helperText={helperText}
    slotProps={{
      input: {
        ...inputProps,
      },
    }}
  >
    {!!initialOptionValue?.length && (
      <MenuItem key={`${id}-initial`} value={initialOptionValue}>
        {initialOptionLabel}
      </MenuItem>
    )}
    {options?.map(({ value, label }) => (
      <MenuItem key={`${id}-${value}`} value={value}>
        {label}
      </MenuItem>
    ))}
  </CustomTextField>
);

export default SelectField;
